var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNounPropeller6549197(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 80",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#87C9ED",
    d: "M30.723,32c.03,1.679,2.526,1.678,2.556,0-.03-1.678-2.526-1.679-2.556,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#87C9ED",
    d: "M25.669,32c0,3.491,2.84,6.331,6.331,6.331,8.379-.297,8.377-12.366,0-12.662-3.491,0-6.331,2.84-6.331,6.331Zm9.609,0c-.137,4.331-6.419,4.331-6.556,0,.137-4.332,6.419-4.33,6.556,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#87C9ED",
    d: "M49.717,23.121c-5.157-2.921-9.548-1.868-12.72,2.229,3.061,2.155,4.284,6.837,2.501,10.257,1.842,.116,4.416,.738,6.965,2.896,1.353,1.186,3.049,1.778,4.687,1.796,3.405-.124,4.695-2.577,4.863-6.443,.132-4.378-2.221-8.391-6.296-10.734Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#87C9ED",
    d: "M25.34,27.016c2.155-3.074,6.852-4.301,10.278-2.509,.118-1.847,.736-4.431,2.885-6.97,1.773-1.944,2.429-5.374,1.044-7.25-.999-1.441-2.914-2.216-5.69-2.3-4.363-.115-8.391,2.22-10.734,6.295-1.921,3.341-2.198,7.048-.705,9.444,.729,1.17,1.705,2.267,2.923,3.29Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#87C9ED",
    d: "M27.021,38.663c-3.074-2.152-4.305-6.844-2.519-10.271-1.842-.116-4.416-.738-6.965-2.896-1.947-1.772-5.372-2.428-7.249-1.043-1.442,.999-2.216,2.913-2.301,5.69-.458,6.278,5.78,12.419,12.072,12.393,3.043,.038,5.028-1.664,6.961-3.873Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#87C9ED",
    d: "M38.665,36.977c-2.153,3.078-6.853,4.309-10.282,2.516-.118,1.847-.736,4.431-2.885,6.969-1.773,1.945-2.429,5.372-1.044,7.249,.976,1.504,3.309,2.321,6.042,2.306,7.493,.35,14.705-9.146,11.088-15.744-.732-1.176-1.709-2.278-2.919-3.296Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounPropeller6549197);
export default __webpack_public_path__ + "static/media/noun-propeller-6549197.f940c47142fc1e74fe90590d201361ab.svg";
export { ForwardRef as ReactComponent };